import { useEffect, useState } from "react";
import api from "../lib/api";
import { PageHeader, EmptyState } from "../components/Section";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogTrigger } from "../components/ui/dialog";

export default function Blog() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/blog").then((r) => setItems(r.data)).catch(() => {}); }, []);
  return (
    <div data-testid="blog-page">
      <PageHeader eyebrow="ARTICLES & REFLECTIONS" title="From the Council"
        subtitle="Teachings, encouragements, and news from the assembly." />
      <section className="py-20">
        <div className="max-w-6xl mx-auto px-6 lg:px-10">
          {items.length === 0 ? <EmptyState /> : (
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {items.map((p) => (
                <Dialog key={p.id}>
                  <DialogTrigger asChild>
                    <button data-testid={`blog-card-${p.id}`} className="text-left border hairline rounded-xl overflow-hidden surface group hover:border-gold/50 transition-colors duration-300 focus:outline-none focus:ring-2 focus:ring-gold">
                      {p.image_url && <div className="aspect-[16/9] overflow-hidden"><img src={p.image_url} alt={p.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500" /></div>}
                      <div className="p-6">
                        <div className="font-accent text-[10px] text-gold mb-2">{new Date(p.created_at).toLocaleDateString()} · {p.author}</div>
                        <h3 className="font-display text-2xl text-white">{p.title}</h3>
                        <p className="mt-3 text-sm text-zinc-400 leading-relaxed">{p.excerpt}</p>
                      </div>
                    </button>
                  </DialogTrigger>
                  <DialogContent className="max-w-2xl bg-[#0a1930] border-zinc-800 max-h-[80vh] overflow-y-auto">
                    <DialogHeader>
                      <DialogTitle className="font-display text-2xl text-white">{p.title}</DialogTitle>
                    </DialogHeader>
                    <div className="font-accent text-[10px] text-gold">{new Date(p.created_at).toLocaleDateString()} · {p.author}</div>
                    {p.image_url && <img src={p.image_url} alt="" className="rounded-lg" />}
                    <div className="whitespace-pre-line text-zinc-300 leading-relaxed">{p.content}</div>
                  </DialogContent>
                </Dialog>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
}
